import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
import "react-toastify/dist/ReactToastify.css";
// material
import { Stack, Container, TextField, Button, CircularProgress } from "@mui/material";
import { insertcountry } from "src/api/commonapi";

import { notification } from "src/utils/messages";
import { useState } from "react";

// ----------------------------------------------------------------------

export default function CountryForm({ setIsFormSubmitted }) {
  const [isLoading, setIsLoading] = useState(false);

  const CountySchema = Yup.object().shape({
    countryname: Yup.string().required("Country Name is required")
  });

  const formik = useFormik({
    initialValues: {
      countryname: ""
    },
    validationSchema: CountySchema,

    onSubmit: async (e, { resetForm }) => {
      const inputemail = e.countryname;

      const logindata = {
        country_name: inputemail
      };
      const jslogindata = JSON.stringify(logindata);
      setIsLoading(true);
      const resp = await insertcountry(jslogindata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      if (resp.status == 1) {
        resetForm();
        setIsFormSubmitted(true);
      }
      notify();
    }
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <Container>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoCorrect="false"
              autoComplete=""
              type="text"
              label="Enter Country Name"
              {...getFieldProps("countryname")}
              error={Boolean(touched.countryname && errors.countryname)}
              helperText={touched.countryname && errors.countryname}
            />
          </Stack>

          <Button
            style={{ marginTop: "15px" }}
            type="submit"
            variant="contained"
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
          >
            Add Country
          </Button>
        </Form>
      </FormikProvider>
    </Container>
  );
}
